export class HeaderMenuIcon {

  path: string;
  alt: string;

}
